/**
 * @generated SignedSource<<3eed26575b444bafcd7b74276c849d1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CampaignInputProfileInfluencer$data = {
  readonly profile: {
    readonly birthday: any | null;
    readonly commonName: string | null;
    readonly gender: string | null;
  };
  readonly " $fragmentType": "CampaignInputProfileInfluencer";
};
export type CampaignInputProfileInfluencer$key = {
  readonly " $data"?: CampaignInputProfileInfluencer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CampaignInputProfileInfluencer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CampaignInputProfileInfluencer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InfluencerInfo",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "commonName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "gender",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "birthday",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Influencer",
  "abstractKey": null
};

(node as any).hash = "e1e1027485b71ca03f8844c46f3cfda4";

export default node;
